/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_blog_post_not_found = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post not found`)
};

const es_blog_post_not_found = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículo no encontrado`)
};

const de_blog_post_not_found = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitrag nicht gefunden`)
};

const nl_blog_post_not_found = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bericht niet gevonden`)
};

const fr_blog_post_not_found = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Article introuvable`)
};

const it_blog_post_not_found = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articolo non trovato`)
};

const pt_br2_blog_post_not_found = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artigo não encontrado`)
};

const pt_blog_post_not_found = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artigo não encontrado`)
};

const ja_blog_post_not_found = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記事が見つかりません`)
};

const zh_blog_post_not_found = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文章未找到`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const blog_post_not_found = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.blog_post_not_found(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("blog_post_not_found", locale)
	if (locale === "en") return en_blog_post_not_found(inputs)
	if (locale === "es") return es_blog_post_not_found(inputs)
	if (locale === "de") return de_blog_post_not_found(inputs)
	if (locale === "nl") return nl_blog_post_not_found(inputs)
	if (locale === "fr") return fr_blog_post_not_found(inputs)
	if (locale === "it") return it_blog_post_not_found(inputs)
	if (locale === "pt-BR") return pt_br2_blog_post_not_found(inputs)
	if (locale === "pt") return pt_blog_post_not_found(inputs)
	if (locale === "ja") return ja_blog_post_not_found(inputs)
	return zh_blog_post_not_found(inputs)
};